// frontend/src/utils/chatApi.js
import { API_URL } from '../config';

export async function selectOrCreateConversation(peerId) {
  const token = localStorage.getItem('token') || '';
  const res = await fetch(`${API_URL}/api/chat/select_or_create`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ recipientId: peerId }),
  });
  if (!res.ok) throw new Error('Failed to select/create conversation');
  const chat = await res.json();
  return chat?._id;
}
